import * as React from "react";

export class Arrow extends React.Component<{
    text: string | JSX.Element
    classModifier?: string
    handler: Function | any
}, {}> {
    baseClass: string

    constructor(props) {
        super(props);
        this.baseClass = "rj-superbanner__arrow";
    }

    render() {
        let cls = `${this.baseClass}${(this.props.classModifier ? ` ${this.baseClass}--${this.props.classModifier}` : "")}`;
        let dataUat = this.props.classModifier ? `superbanner-arrow-${this.props.classModifier}` : "superbanner-arrow";
        return (
            <div onClick={this.props.handler} className={cls} data-uat={dataUat}>{this.props.text}</div>
        )
    }
}